var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.978,
    height: 20.348,
    viewBox: "0 0 20.978 20.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".achart,.bchart{fill:#fff;}.bchart{stroke:#fff;stroke-width:0.4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-448.8 -304)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "achart",
    d: "M309.478,63.872H307.39V61.784a.759.759,0,1,0-1.518,0v2.088h-2.088a.759.759,0,0,0,0,1.518h2.088v2.088a.759.759,0,1,0,1.518,0V65.39h2.088a.759.759,0,0,0,0-1.518Z",
    transform: "translate(158.579 242.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bchart",
    d: "M4.646,195.05a.6.6,0,0,0,.244.047.63.63,0,0,0,.427-.17l4.253-4.07h8a3.013,3.013,0,0,0,3.011-3.011v-4.538a.617.617,0,1,0-1.234,0v4.538a1.779,1.779,0,0,1-1.777,1.777H9.319a.63.63,0,0,0-.427.17L5.5,193.035v-2.788a.619.619,0,0,0-.617-.617H3.011a1.779,1.779,0,0,1-1.777-1.777v-8.885a1.785,1.785,0,0,1,1.777-1.784h7.278a.617.617,0,0,0,0-1.234H3.011A3.013,3.013,0,0,0,0,178.961v8.885a3.013,3.013,0,0,0,3.011,3.011H4.273v3.629A.616.616,0,0,0,4.646,195.05Z",
    transform: "translate(449 129.051)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.6980c4a34ca112224ecee3a4bb5d782d.svg";
export { ForwardRef as ReactComponent };